import { useContext, useMemo } from 'react'

import { SerializableAppointmentInfo } from '../../models/SerializableSdkTypes/SerializableAppointmentInfo'
import { AuthContext } from '../../providers'
import { useGetAppointmentsQuery } from '../../redux/api'
import { loggingAssert } from '../../utils/handleError/loggingAssert'

interface Hook {
  appointmentLookup: { [id: string]: SerializableAppointmentInfo } | undefined
}

export const useAppointmentLookup = (appointmentIdList: string[]): Hook => {
  const { currentUser, userShopId } = useContext(AuthContext)
  const accessToken = loggingAssert(
    'No access token found where one was expected',
    currentUser?.accessToken
  )
  const shopId = loggingAssert(
    'No shop ID found where one was expected',
    userShopId
  )
  const { data: appointments } = useGetAppointmentsQuery(
    {
      authorization: accessToken,
      shop: shopId,
      appointment: appointmentIdList
    },
    {
      skip: appointmentIdList.length === 0
    }
  )
  const appointmentLookup = useMemo(() => {
    if (appointmentIdList.length === 0) {
      return {}
    }

    if (!appointments) {
      return undefined
    }
    const activeAppointments = appointments.filter(
      (appt) => appt.info.archived !== true
    )
    const dict: { [id: string]: SerializableAppointmentInfo } = {}
    ;(activeAppointments || []).forEach(
      (entry) => (dict[entry.id!] = entry.info!)
    )
    return dict
  }, [appointmentIdList.length, appointments])

  return {
    appointmentLookup
  }
}
